// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultKPIPropsOnChangeValue.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import { get, omitBy, getOr, isNil, includes } from 'lodash/fp';
import { action } from 'mobx';

export default (reportPartDetails) =>
  action(
    'OnChangeKPIProps',
    (
      schemaData: any,
      changedKey: string,
      changedKeyPath: any,
      changedValue: any,
      changedOthersInfo: any,
      derivedChange: any
    ) => {
      const groupData = changedKeyPath && changedKeyPath.length ? get(changedKeyPath, schemaData) : schemaData;
      const fieldData = groupData[changedKey];
      fieldData && (fieldData.value = changedValue);

      const reportPartContent = reportPartDetails.reportPartContent || {};
      const generalInfo = getOr({}, 'generalInfo', schemaData);
      const view = getOr({}, 'view', schemaData);
      const dataRefreshInterval = getValue('dataRefreshInterval', view) || {};

      const chartProperties = {
        backgroundImage: getValue('kpi.backgroundImage', schemaData)
          || reportPartDetails.reportPartContent.getReportPartProperties('backgroundImage'),
        chartType: getValue('chartType', generalInfo),
        optionByType: {
          metricTile: reportPartDetails.reportPartContent.getMetricTileList()
        },
        view: {
          numRows: getValue('numRows', view),
          numCols: getValue('numCols', view),
          cellSize: getValue('cellSize', view),
          dataRefreshInterval
        }
      };

      // remove properties which don't have for selected chart-type
      chartProperties.optionByType = omitBy(isNil, chartProperties.optionByType);

      if (changedKey === 'chartType') {
        reportPartContent.setChartType(chartProperties.chartType);
      }

      derivedChange && derivedChange(chartProperties);
      changedKey !== 'chartType' && reportPartDetails.setReportPartProperties(chartProperties);

      if (includes(changedKey, ['numRows', 'numCols', 'cellSize'])) {
        reportPartContent.setNeedUpdateLayoutStore(true);
      }
      return Promise.resolve({
        needToUpdate: false,
        chartProperties
      });
    }
  );

/**
 * Get value
 * @param {string} key
 * @param {Object} obj
 */
function getValue(key: string, obj: any) {
  return get([key, 'value'].join('.'), obj);
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartKPI/Izenda.DefaultKPIPropsOnChangeValue.js